"use client"
import { useContext } from 'react';
import { AuthContext } from '@/components/auth/auth-provider';
import type { User, AppSettings } from '@/types';

interface AuthContextType extends AppSettings {
  user: User | null;
  users: User[]; // Adicionando a lista de todos os usuários
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
  loading: boolean;
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context as AuthContextType;
};
